export default __webpack_public_path__ + "static/forgery_staff_upgrade-e4940e7534b60ad56de381ccba57e06b.png";